import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Users } from "lucide-react";
import { useDismissPopover } from "../hooks/useDismissPopover";
import type { Pilot } from "../types/chain";

interface PresencePopoverProps {
  pilots: Pilot[];
}

export function PresencePopover({ pilots }: PresencePopoverProps) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const panelRef = useRef<HTMLDivElement>(null);

  useDismissPopover({
    open,
    triggerRef,
    panelRef,
    onDismiss: () => setOpen(false),
  });

  const toggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!open) {
      const r = e.currentTarget.getBoundingClientRect();
      setPos({ top: r.bottom + 4, left: r.left });
    }
    setOpen((o) => !o);
  };

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className="system-node__presence nodrag"
        onClick={toggle}
      >
        <Users size={11} aria-hidden />
        {pilots.length}
      </button>
      {open &&
        pos &&
        createPortal(
          <div
            ref={panelRef}
            className="presence-popover"
            style={{ top: pos.top, left: pos.left }}
          >
            <ul className="presence-popover__list">
              {pilots.map((p) => (
                <li key={p.character_id} className="presence-popover__row">
                  <img
                    className="presence-popover__portrait"
                    src={`https://images.evetech.net/characters/${p.character_id}/portrait?size=64`}
                    alt=""
                    width={24}
                    height={24}
                  />
                  <span className="presence-popover__name">
                    {p.name}
                    {p.ship_type_name && (
                      <span className="presence-popover__ship">
                        {` · ${p.ship_type_name}`}
                      </span>
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>,
          document.body,
        )}
    </>
  );
}
